module.exports = __webpack_public_path__ + "assets/img/grey-download.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/grey-download.png
// module id = 1941
// module chunks = 0